import React from "react";
import styled from "styled-components";

export default styled.div`
  color: #ffffff;
  font-size: 3.2rem;
`;
